import React, { useState, useEffect } from "react";
import { Form, message, Modal, Button } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

import "../../../../App.css";
import SurveyComponent from "../survey/SurveyComponent.jsx";
import CustomLoader from "../../common/customLoader/index.js";
import { useDispatch } from "react-redux";
import { feedbackRequestsPreviewThunk } from "../../../store/thunks/feedbackRequestsThunk.js";
import TopContainerHeader from "../../../components/molecules/TopComponentHeader/index.js";

const FeedbackRequestPreview = () => {
  const dispatch = useDispatch();
  
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);
  const [feedbackForm, setFeedbackForm] = useState({});
  const [form] = Form.useForm();
  const location = useLocation();

  const id = location.pathname.split("/")[3];
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  const getFormDetail = async () => {
    const allKeys = Object.keys(localStorage);
    let removeItems = [
      "@secure.s.isSubMenuActive",
      "@secure.j.auditFormInput",
      "@secure.s.auditFormCall",
      "@secure.n.totalAuditedCount",
      "@secure.j.parameterSelectedList",
      "@secure.n.auditedQuestionScoreCount",
      "@secure.n.auditedQuestionCount",
      "@secure.j.countMap",
      "@secure.s.clickedLink",
      "@secure.s.auditScore",
      "@secure.j.timeStampsDetails",
      "@secure.n.weightageFlag",
      "@secure.j.updatedQMF",
      "@secure.s.savedAuditId",
      "@secure.j.savePayloadRequestParams",
    ];

    allKeys.forEach((key) => {
      if (removeItems.includes(key)) {
        localStorage.removeItem(key);
      }
    });

    const payload = {id};
    await dispatch(feedbackRequestsPreviewThunk(payload))
      .unwrap()
      .then((response) => {
        let parsedFeedbackForm = JSON.parse(response.formContent);
        let questions = parsedFeedbackForm?.elements;
        questions && setFeedbackForm(questions);
        setShowLoader(false);
      })
      .catch((error) => {
        error?.data?.message && message.error(error?.data?.message);
      });
  };

  useEffect(() => {
    getFormDetail();
    document.title = "Customer Satisfaction Survey";
  }, []);

  const headLine = feedbackForm?.elements?.meta?.headline;
  const surveyJSON = feedbackForm && feedbackForm;

  /* ---------------------------------------------------------
      NEW MODAL SURVEY SECTION (ADDED WITHOUT IMPACTING EXISTING)
  ------------------------------------------------------------*/

  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [currentStep, setCurrentStep] = useState(0);
  // const [answers, setAnswers] = useState({});

  // const surveyQuestions = [
  //   {
  //     id: 1,
  //     question: "How satisfied are you with our service?",
  //     options: ["Very Satisfied", "Satisfied", "Neutral", "Unsatisfied"],
  //   },
  //   {
  //     id: 2,
  //     question: "Was the staff polite?",
  //     options: ["Yes", "No", "Somewhat"],
  //   },
  //   {
  //     id: 3,
  //     question: "Would you recommend us?",
  //     options: ["Definitely", "Maybe", "No"],
  //   },
  // ];

  // const handleOptionSelect = (qid, option) => {
  //   setAnswers((prev) => ({ ...prev, [qid]: option }));
  // };

  // const nextQuestion = () => {
  //   if (currentStep < surveyQuestions.length - 1) {
  //     setCurrentStep(currentStep + 1);
  //   }
  // };

  // const prevQuestion = () => {
  //   if (currentStep > 0) {
  //     setCurrentStep(currentStep - 1);
  //   }
  // };

  // const handleSubmitSurvey = () => {
  //   console.log("Survey Answers:", answers);
  //   setIsModalOpen(false);
  // };

  /* ------------------------------------------------------- */

  return (
    <div className="single-page surveyCom-container feedBackPreview">
      <CustomLoader showLoader={showLoader} />
      {/* <TopContainerHeader
        sectionTitle=""
        sectionDescription={""}
        hasSectionButton={true}
        sectionButtons={[                
                {
                  key: "back",
                  isVisible: true,
                  itemType: "",
                  itemName: "Closed Feedback Requests",
                  itemClassName: "downloadAllLoader-container defaultGreyBtn",
                  onClick: () => {navigate("/feedback-requests/closed")}
                },
              ]}
        hasFilter={false}
        buttonTitle=""
      /> */}
      
      {secureLocalStorage.getItem("role") !== "" &&
        (secureLocalStorage.getItem("role") === "admin" ||
          secureLocalStorage.getItem("role") === "qc") && (
          <>
            <div className="surveyCom-outer-container">
              <div className="surveyCustom-inner-container">
                <span>{headLine}</span>

                {surveyJSON &&
                  surveyJSON.questions &&
                  surveyJSON.questions.length > 0 && (
                    <SurveyComponent
                      surveyJSON={surveyJSON}
                      id={id}
                      source="preview"
                    />
                  )}
              </div>
            </div>

            {/* NEW BUTTON TO OPEN SURVEY MODAL */}
            {/* <div style={{ marginTop: 20 }}>
              <Button type="primary" onClick={() => setIsModalOpen(true)}>
                Start Popup Survey
              </Button>
            </div> */}
          </>
        )}

      {/* ----------------- NEW POPUP SURVEY MODAL ----------------- */}
      {/* <Modal
        open={isModalOpen}
        footer={null}
        title={<div className="headermodaltitle">Quick Survey</div>}
        onCancel={() => setIsModalOpen(false)}
        className="all-modal"
      >
        <div className="survey-wrapper pb-16">
          <h5 className="question-title">
            {surveyQuestions[currentStep].question}
          </h5>

          <div className="options-wrap">
            {surveyQuestions[currentStep].options.map((opt) => (
              <div key={opt} className="optionRow">
                <input
                  type="radio"
                  name={`q_${surveyQuestions[currentStep].id}`}
                  value={opt}
                  checked={
                    answers[surveyQuestions[currentStep].id] === opt
                  }
                  onChange={() =>
                    handleOptionSelect(surveyQuestions[currentStep].id, opt)
                  }
                />
                <label>{opt}</label>
              </div>
            ))}
          </div>
             </div>
          <div className="modalFooter survey-footer">
            <div className="modalBtns">
              {currentStep > 0 && (
              <Button className="defaultBtn defaultGreyBtn" onClick={prevQuestion}>
                Previous
              </Button>
            )}

            {currentStep < surveyQuestions.length - 1 ? (
              <Button className="defaultBtn" onClick={nextQuestion}>
                Next
              </Button>
            ) : (
              <Button className="defaultBtn" onClick={handleSubmitSurvey}>
                Submit
              </Button>
            )}
            </div>
            
          </div>
       
      </Modal> */}
      {/* ---------------------------------------------------------- */}
    </div>
  );
};

export default FeedbackRequestPreview;
